import { LitElement, css, html } from '@lit'
import styles from '@nova/styles'

class NovaCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  render() {
    return html`
      <div>
        <slot @change=${this.onChange} name="input"></slot>
        <slot name="label"></slot>
        <slot name="checkmark"></slot>
      </div>
    `
  }

  static styles = [
    styles.variables,
    css`
      ::slotted(input) {
        width: var(--nova-width, 16px);
        height: var(--nova-height, 16px);
        position: absolute;
        top: 0;
        left: 0;
        border: none;
        appearance: none;
        padding: 0;
        margin: 0;
      }

      ::slotted(label) {
        cursor: pointer;
      }

      ::slotted(label):before {
        content: '';
        -webkit-appearance: none;
        background-color: transparent;
        border: 1px solid var(--nova-brand-ink) !important;
        width: var(--nova-width, 16px);
        height: var(--nova-height, 16px);
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 5px;
        box-sizing: border-box !important;
        border-radius: var(--nova-border-radius-l);
      }

      :host {
        position: relative;
        display: block;
      }

      :host([checked='true']) ::slotted(label):after {
        content: '';
        position: absolute;
        top: 7px;
        left: var(--nova-check-left, 4px);
        width: var(--nova-check-width, 8px);
        height: var(--nova-check-height, 8px);
        background-color: var(--nova-brand-ink);
        border-radius: var(--nova-border-radius-l);
      }
    `,
  ]
}

customElements.define('nova-checkbox-wrapper', NovaCheckboxWrapper)
